import React from "react";
import { Container } from "react-bootstrap";

import "../../assets/css/revised_css/components/controlManagerThemes/controlManager.css"
import '../../assets/css/revised_css/components/controlManagerThemes/bootstrap/index.css'

import { ControlCreator } from "./controlCreator";
import { ControlManagerContexts } from "./controlManagerContexts";

export function NewControlManager({ content, schemas, source, onChange = () => { }, onSubmit = ()=>{}, objectMetadata, options }) {
  const contextProps = {content, schemas, source, onChange, objectMetadata, options, onSubmit}
  return (
    <Container
    className={'control-manager-root-container ' + (options?.isModal ? "":"h-100")}>
      <ControlManagerContexts {...contextProps}>
          <ControlCreator {...contextProps}/>
      </ControlManagerContexts>
    </Container>
  )
}